import "./footer.css";
import React, { useEffect, useState, useRef } from "react";

const Footer = () => {
  const [showShareLinkSuccess, setShowShareLinkSuccess] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const handleShare = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setShowShareLinkSuccess(true);
      setShareUrl(window.location.href);
    });
  };

  return (
    <>
      {showShareLinkSuccess && (
        <div className="modal-share-link-success-message">
          <div
            class="close-modal-share-link-success-message"
            onClick={() => setShowShareLinkSuccess(false)}
          >
            &#10006;
          </div>
          <p>Link copied to clipboard!</p>
          <div className="social-i-wrapper">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="social-i fab fa-facebook"></i>
            </a>{" "}
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="social-i fab fa-linkedin"></i>
            </a>{" "}
            <a
              href={`https://mail.google.com/mail/?view=cm&fs=1&to=&su=Subject&body=${shareUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="social-i fa-brands fa-google"></i>
            </a>{" "}
            <a
              href={`https://outlook.live.com/mail/deeplink/compose?subject=Your%20Subject&body=${shareUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="social-i fa-solid fa-envelope"></i>
            </a>
            <a
              href={`https://wa.me/?text=Catastrophic%20Wildfire%20Prevention%20Consortium%20${shareUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="social-i fa-brands fa-whatsapp"></i>
            </a>
          </div>
        </div>
      )}
      <footer>
        <div className="footer large-screen-limit">
          <div className="footer-logo-group">
            <div className="footer-column">
              <div className="footer-logo">
                <a href="/">
                  <img src="/images/header-footer/newlogo3.svg" alt="arise" />
                </a>
              </div>
              <div className="copyright">
                &copy; 2024-2025. All rights reserved.
              </div>
            </div>
          </div>
          <div className="footer-links-group">
            <div className="footer-column">
              <h5>Company</h5>
              <div className="footer-links">
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/about">About</a>
                  </li>
                  <li>
                    <a href="/sponsors">Sponsor</a>
                  </li>
                  <li>
                    <a href="/contact-us">Contact</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="footer-column">
              <h5>Scorecard</h5>
              <div className="footer-links">
                <ul>
                  <li>
                    <a href="/scorecard">Scorecard Home</a>
                  </li>

                  <li>
                    <a href="/scorecard/instructions">Scorecard Instructions</a>
                  </li>

                  <li>
                    <a href="/scorecard/faq">Scorecard FAQs</a>
                  </li>
                  <li>
                    <a href="/scorecard/about">About Scorecard</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer-column">
              <h5>Showcase</h5>
              <div className="footer-links">
                <ul>
                  <li>
                    <a href="/showcase/innovations">Innovations</a>
                  </li>
                  <li>
                    <a href="/showcase/presentations">Presentations</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="footer-column">
              <h5>Follow Us</h5>
              <div className="social-icons">
                <a
                  href="https://www.linkedin.com/showcase/catastrophic-wildfire-prevention-consortium/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Link to our LinkedIn page"
                >
                  <i className="fab fa-linkedin"></i>
                </a>
                <a
                  href="https://www.facebook.com/people/Catastrophic-Wildfire-Prevention-Consortium-CWPC/61575999569773/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Link to our Facebook page"
                >
                  <i className="fab fa-facebook"></i>
                </a>
                <a
                  href="https://www.youtube.com/channel/UCzoGiPxrlKJfSUCeqMtmzmw"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Link to our youtube page"
                >
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@claudia_brenner_sf"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Link to our Tiktok page"
                >
                  <i className="fab fa-tiktok"></i>
                </a>
                <a
                  href="https://www.instagram.com/cwpc_wildfire_resilience?igsh=NTc4MTIwNjQ2YQ=="
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Link to our Instagram page"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <div
                  className="share-link"
                  target="_blank"
                  onClick={handleShare}
                  aria-label="Get link to share our website"
                >
                  <i className="fa-sharp fa-solid fa-share-nodes"></i>
                </div>
              </div>
              <div className="footer-links">
                <ul>
                  <li>
                    <a href="/scorecard/subscribe">
                      <button className="subscribe-btn">Subscribe</button>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
